import { jsPDF } from 'jspdf'
import autoTable from 'jspdf-autotable'

import { formatHMS, formatShortDate } from './BaltoAcademy.helpers'

// blurple-600 (sRGB) — matches the scorecard PDF header color.
const HEADER_FILL = [57, 52, 236]

export const getUserPdfFileName = (identifier) => `${identifier || 'user'}-balto-academy.pdf`

// `trackings` is expected pre-sorted into the table's display order.
export const buildUserTrackingsPdf = ({ identifier, trackings }) => {
  // eslint-disable-next-line new-cap -- jsPDF is the library's exported constructor name
  const doc = new jsPDF({ unit: 'pt', format: 'letter' })

  doc.setFontSize(16)
  doc.text('Balto Academy — Course Report', 40, 48)

  doc.setFontSize(11)
  doc.setTextColor(110)
  doc.text(identifier || '', 40, 68)

  autoTable(doc, {
    startY: 86,
    head: [['Course', 'Progress', 'Total Time', 'Started', 'Completed']],
    body: trackings.map((tracking) => [
      tracking.course?.title ?? '—',
      `${Math.round(tracking.progressPercent || 0)}%`,
      formatHMS(tracking.totalTime),
      formatShortDate(tracking.commenced),
      formatShortDate(tracking.completed),
    ]),
    styles: { fontSize: 9, cellPadding: 6 },
    headStyles: { fillColor: HEADER_FILL },
  })

  return doc
}
